import { CircularProgress, Box, Typography } from '@mui/material';

const LoadingIndicator = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      flexDirection="column"
    >
      <CircularProgress size={50} />
      <Typography variant="h6" mt={2} color="text.secondary">
        Loading...
      </Typography>
    </Box>
  );
};

export default LoadingIndicator;
